import { Table } from 'antd';
import type { TablePaginationConfig } from 'antd/es/table';
import type { SorterResult } from 'antd/es/table/interface';
import { localize } from 'mixins/helpers';
import React, { FC, useMemo } from 'react';
import { ApiCallStatistic } from '/react4xp/parts/admin-api-call-statistics/types';
import { DEFAULT_PAGE_SIZE } from '../utils/constants';
import { CallStatisticsSortState } from '../utils/types';
import { getCallStatisticsColumns } from './call-statistics-columns';

interface CallStatisticsTableProps {
    apiNames: Record<string, string>;
    data: ApiCallStatistic[];
    isLoading: boolean;
    pagination: TablePaginationConfig;
    sort: CallStatisticsSortState;
    translations: Record<string, string>;
    onChange: (
        pagination: TablePaginationConfig,
        tableFilters: Record<string, any>,
        sorter: SorterResult<ApiCallStatistic> | SorterResult<ApiCallStatistic>[]
    ) => void;
}

export const CallStatisticsTable: FC<CallStatisticsTableProps> = ({
    apiNames,
    data,
    isLoading,
    onChange,
    pagination,
    sort,
    translations,
}) => {
    const columns = useMemo(
        () =>
            getCallStatisticsColumns({
                apiNames,
                pagination,
                sort,
                translations,
            }),
        [apiNames, pagination, sort, translations]
    );

    return (
        <Table<ApiCallStatistic>
            rowKey={(record) => `${record.taxpayerCode}-${record.apiCode}-${record.statDate}`}
            columns={columns}
            dataSource={data}
            loading={isLoading}
            locale={{
                emptyText: localize('admin-api-stat-no-data', translations),
            }}
            pagination={{
                ...pagination,
                pageSize: pagination.pageSize || DEFAULT_PAGE_SIZE,
                showSizeChanger: false,
                showTotal: undefined,
                responsive: false,
                className: 'admin-api-call-statistics__pagination',
            }}
            scroll={{ x: 1100 }}
            onChange={onChange}
        />
    );
};